import { createSlice } from "../helper";

const budgetAnalyticsSlice = createSlice({
  name: "budgetAnalytics",
  initialState: { budgetId: null },
  reducers: {
    updateBudgetId: (state, action) => {
      state.budgetId = action.payload;
    }
  }
});

export const budgetAnalyticsActions = budgetAnalyticsSlice.actions;

export default budgetAnalyticsSlice.reducer;
